.blacklist-filter {
	cursor: help;
}
